import type { Locale } from '@change-corgi/config/locales';

export async function setupIntl(_: { locale: Locale }): Promise<void> {
	return Promise.resolve();
}
